import {Component, OnInit, ViewChild, ElementRef} from '@angular/core';
import {Md5} from "ts-md5";
import {CPCUser} from "../login/CPCUser";
import {Http} from "@angular/http";
import {CpcWebApiService} from "../cpc-web-api.service";
import {Router} from "@angular/router";
import {CpcSysInfoService} from "../cpc-sys-info.service";

@Component({
  selector: 'app-mobile-login',
  templateUrl: './mobile-login.component.html',
  styleUrls: ['./mobile-login.component.scss']
})
export class MobileLoginComponent implements OnInit {
  get userInfo(): CPCUser {
    return this._userInfo;
  }

  set userInfo(value: CPCUser) {
    this._userInfo = value;
  }
  infoError: boolean = false;
  private _userInfo: CPCUser = new CPCUser();
  errorMessage = "";
  isLogin = false;
  needMd5 = true;
  @ViewChild('ui') uiInput: ElementRef;
  @ViewChild('pw') pwInput: ElementRef;
  @ViewChild('tip') tip: ElementRef;

  constructor(private webapi: CpcWebApiService,
              private router: Router,
              public sysInfo: CpcSysInfoService, private http: Http) {
  }

  data: any;
  backgroundUlr;
  entcode;
  telImgUrl;
  telText;
  qqClickUrl;
  qqImgUrl;
  qqText;
  webtoolURL;
  IsPC() {
    let userAgentInfo = navigator.userAgent;
    let Agents = ["Android", "iPhone",
      "SymbianOS", "Windows Phone",
      "iPad", "iPod"];
    let flag = true;
    for (let v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) > 0) {
        flag = false;
        break;
      }
    }
    return flag;
  }
  ngOnInit() {

    let url = '/getEntCode.jsp?v=' + Math.floor(Math.random() * 1000000);
    // console.log(url);
    let aa;
    this.http.get(url).toPromise().then(response => {
      aa = response.json();
      // console.log( aa);
      if (aa) {
        for (let i = 0; i < aa.length; i++) {
          if (aa[i].domain == window.location.hostname) {
            this.entcode = aa[i].entcode;
            this.sysInfo.logoUrl = aa[i].logourl;
            this.sysInfo.title = aa[i].title;
            this.sysInfo.loginlogourl = aa[i].loginlogourl;
            this.backgroundUlr = aa[i].background_url;
            if (aa[i].hotline_url)
              this.telImgUrl = aa[i].hotline_url;
            if (aa[i].hotline_number)
              this.telText = aa[i].hotline_number;
            if (aa[i].qq_number)
              this.qqClickUrl = "http://wpa.qq.com/msgrd?v=3&uin=" + aa[i].qq_number + "&site=qq&menu=yes";
            if (aa[i].qq_url)
              this.qqImgUrl = aa[i].qq_url;
            if (aa[i].qq_text)
              this.qqText = aa[i].qq_text;
            document.title = this.sysInfo.title;
            if(aa[i].webtoolcrc32)
              this.webapi.WebtoolCRC32 = aa[i].webtoolcrc32;
            if(aa[i].webtool2crc32)
              this.webapi.Webtool2CRC32  = aa[i].webtool2crc32;
            if(aa[i].webtoolurl)
              this.webtoolURL  = aa[i].webtoolurl;
            if(aa[i].loginguid && aa[i].loginguid.length>0){
              this.uiInput.nativeElement.value = aa[i].loginguid;
              this.doLogin();
            }
            if(aa[i].sso_logout_url && aa[i].sso_logout_url.length>0){
              this.webapi.sso_logout_url = aa[i].sso_logout_url;
            }



          }
        }

      }


    });
  }

  doLogin() {
    if (this.isLogin) return false;
    this.isLogin = true;
    this.infoError = false;
    this.errorMessage = "";
    // 清除缓存
    window.sessionStorage.removeItem('TopBarInfo');
    window.sessionStorage.removeItem('SQueueInfo');
    window.sessionStorage.removeItem('docInfo');
    window.localStorage.removeItem('sysInfo');
    // //记住用户
    // const rememberInfo = new CPCUser();
    // rememberInfo.userId = this.userInfo.userId;
    // rememberInfo.password = this.userInfo.isRemember ? this.userInfo.password : '';
    // rememberInfo.isRemember = this.userInfo.isRemember;
    // window.localStorage.setItem('CPCLastUserInfo', JSON.stringify(rememberInfo));

    //360极速浏览器自动填充表单不会触发change事件，导致ng2中绑定的模型值没同步，这里手动同步.....mdzz
    this._userInfo.userId = this.uiInput.nativeElement.value;
    this._userInfo.password = this.pwInput.nativeElement.value;
    let randomStr='';
    for(let i=0; i<this._userInfo.password.length; i++){
      randomStr +=Math.floor(Math.random()*10)
    }
    let data = {
      userid: this._userInfo.userId,
      md5sn: Md5.hashStr(this._userInfo.password),
      entcode: this.entcode,
      userpass:'PORTAL'+this.webapi.base64encode(this.webapi.utf16to8(this._userInfo.password+randomStr))
    };
    this.webapi.post('loginuser', 'login', data).then(
      response => {
        this.tip.nativeElement.style.display = 'block';
        //登录成功
        this.isLogin = false;
        let responseData = response.json();
        //打开表单
        let cookieName = 'CPCREDIRECTURL';
        let strCookie = document.cookie;
        let arrCookie = strCookie.split("; ");
        let newUrl;
        for (let i = 0; i < arrCookie.length; i++) {
          let arr = arrCookie[i].split("=");
          if (cookieName == arr[0]) {
            if (arr[1].length > 0) {//说明有表单的连接
              newUrl = arr[1];
              if (newUrl.indexOf('?') > 0) {

                if (newUrl.substring(newUrl.indexOf('?') + 1).length > 0) {
                  newUrl = newUrl + "&loginguid=" + responseData.loginguid;
                }
                else {
                  newUrl = newUrl + "loginguid=" + responseData.loginguid;
                }
              }
              else {
                newUrl = newUrl + "?loginguid=" + responseData.loginguid;
              }

            }
          }
        }
        if (newUrl) {
          window.location.href = newUrl;
        }
        else {
          this.webapi.setLoginGUId(responseData.loginguid);
          this.sysInfo.userInfo.userId = responseData.userid;
          this.sysInfo.userInfo.userName = responseData.username;
          this.sysInfo.userInfo.sysuserid = responseData.sysuserid;
          this.sysInfo.userInfo.md5sn = String(Md5.hashStr(this._userInfo.password));
          this.sysInfo.userInfo.password = this._userInfo.password;
          this.sysInfo.userInfo.email = responseData.email;
          this.sysInfo.userInfo.mobile = responseData.mobil;
          this.sysInfo.userInfo.currmrporgid = responseData.currmrporgid;
          if (responseData.orgofusers.length > 0) {
            if (responseData.orgofusers[0].orgname) {
              this.sysInfo.userInfo.department = responseData.orgofusers[0].orgname;
            }
          }
          this.sysInfo.entId = responseData.entid;
          this.sysInfo.entCode = responseData.entcode;
          this.sysInfo.userInfo.EnablePwd = responseData.EnablePwd;
          // 打开文档的方式
          for(let i=0;i<responseData.sysconfs.length;i++){
            if(responseData.sysconfs[i].confname == 'WEBOpenFileMethod'){
              // console.log(responseData.sysconfs[i]);
              this.sysInfo.openFileStyle = responseData.sysconfs[i].confvalue
            }
            if(responseData.sysconfs[i].confname == 'MenuViewStyle'){
              // console.log(responseData.sysconfs[i]);
              this.sysInfo.menuStyle = responseData.sysconfs[i].confvalue
            }
          }
          //系统信息保存到localStorage,刷新页面时取用
          let sysinfo = {
            entCode:this.sysInfo.entCode,
            entId:this.sysInfo.entId,
            langs:this.sysInfo.langs,
            loginlogourl:this.sysInfo.loginlogourl,
            logoUrl:this.sysInfo.logoUrl,
            menuStyle:this.sysInfo.menuStyle,
            openFileStyle:this.sysInfo.openFileStyle,
            title:this.sysInfo.title,
            userInfo:this.sysInfo.userInfo,
            _browserLang:this.sysInfo._browserLang,
            webapi:this.sysInfo.webapi,
          };
          let Js = JSON.stringify(sysinfo);
          window.localStorage.setItem('sysInfo', Js);
          let aa= JSON.stringify({webtoolcrc32:this.webapi.WebtoolCRC32,webtool2crcr32:this.webapi.Webtool2CRC32,openFiletype:this.sysInfo.openFileStyle});
          window.sessionStorage.setItem('docInfo', aa);
          //loginguid保存到cookie,调用某些jsp时会取
          //this.cs.put("CPCSESSIONID", responseData.loginguid);
          // document.cookie = "CPCSESSIONID=" + responseData.loginguid;
          // this.sysInfo.initSysInfo();
          this.router.navigateByUrl('index');

        }


      }, error => {
        // this.tip.nativeElement.style.display = 'none';
        this.isLogin = false;
        this.infoError = true;
        const errorData = error.json();
        if (errorData.message) {
          this.errorMessage = errorData.message;
        }
      }
    );
    //A
    return false;
  }

}



// WEBPACK FOOTER //
// D:/cpc/sinocc.web/web.X6/www/x6.ng2/src/app/mobile-login/mobile-login.component.ts